/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Perks1Inputs */

const vi_sitesettings_product_perks1 = /** @type {(inputs: Sitesettings_Product_Perks1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ tin cậy (máy tính)`)
};

/**

* @param {Sitesettings_Product_Perks1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_perks1 = /** @type {((inputs?: Sitesettings_Product_Perks1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Perks1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_perks1(inputs)
});
export { sitesettings_product_perks1 as "siteSettings_product_perks" }